export const ENVIRONMENT_PRODUCTION = 'production';

/**
 * Annotation which can be used to identify groups that exist in the neo4j-cloud repo teams.yaml file.
 */
export const NEO4J_CLOUD_REPO_NAME_ANNOTATION = 'neo4j/cloud-repo-name';

/**
 * Used as an optional data placeholder value
 * e.g., for empty cells in a data grid
 */
export const EMPTY_VALUE = 'Unknown';

/**
 * "En dash" (–) used as an optional placeholder for empty values,
 * or as a range separator, e.g., 1990–2000, pages 5–10, or a Monday–Friday.
 */
export const EN_DASH = '\u2013';
